<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <a class="navbar-brand" href="#">
        <img class="navbar-brand-full" :src="url.logo" width="89" height="25" alt="MBCNEXTGEN Logo">
        <img class="navbar-brand-minimized" :src="url.sygnet" width="30" height="30" alt="MBCNEXTGEN Logo">
      </a>
      <SidebarToggler class="d-md-down-none" display="lg"/>
      <ul class="navbar-nav d-md-down-none ml-auto mr-2">
        <li class="nav-item d-md-down-none">
          <DefaultHeaderDropdown :username="username" :type="type" :icon="icon"/>
        </li>
      </ul>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div class="container">
        <div class="row">
          <div class="offset-3 offset-md-0 col-3 col-md-2 text-center text-md-left">
            <a href="https://www.unilevernotices.com/thailand/thai/privacy-notice/notice.html" target="_blank">Privacy</a>
          </div>
          <div class="col-3 col-md-2 text-center text-md-left">
            <a href="https://www.unilevernotices.com/thailand/thai/cookie-notice/notice.html" target="_blank">Cookies</a>
          </div>
          <div class="col-md-4 text-center">
            <b>MBCNEXTGEN <span class="ml-1">&copy; 2018.</span></b>
          </div>
          <div class="col-md-4 text-center text-md-right">
            <b><span class="mr-1">Powered by</span>Creative Me Version 1.0.0</b>
          </div>
        </div>
      </div>
    </TheFooter>
  </div>
</template>
<script>
import Vue from 'vue'
import nav from '@/_nav'
import JWT from '../utils/JWT.js';
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  Footer as TheFooter
} from '@coreui/vue'
Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('walls_token');
export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    'DefaultHeaderDropdown': () => import('./DefaultHeaderDropdown'),
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      navItems: [],
      url: {
        logo: '',
        sygnet: ''
      },
      username:'ไม่พบข้อมูล',
      type: '',
      icon: ''
    }
  },
  async mounted() {
    this.navItems = await this.getNavTabs()
    this.url.logo = process.env.VUE_APP_BASE_URL + 'img/brand/logo.svg'
    this.url.sygnet = process.env.VUE_APP_BASE_URL + 'img/brand/sygnet.svg'
  },
  computed: {
    name() {
      return this.$route.name
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  methods: {
    refreshToken() {
      this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/auth/refresh').then(res => {
        JWT.decode(res.body.data).then(async data => {
          localStorage.setItem('walls_token', data.token)
          localStorage.setItem('walls_encrypt', await JWT.encode(data))
        })
      })
    },
    removeToken() {
      localStorage.removeItem('walls_token')
      localStorage.removeItem('walls_encrypt')
      location.href = '/auth/login'
    },
    async getNavTabs() {
      let data = [],
      value = null
      try {
        const token = await JWT.decode(localStorage.getItem('walls_encrypt'))
        const actionType = token.type
        if (actionType === false || actionType === null || token.token !== localStorage.getItem('walls_token')) {
          this.removeToken()
        }
        if (localStorage.getItem('walls_token') && (actionType === 'dtuser' || actionType === 'adminuser' || actionType === 'miniuser')) {
          this.username = token.username
          if(actionType === 'dtuser'){
            this.type = ' DT | '
            this.icon = 'fas fa-user-secret'
          }else if(actionType === 'miniuser'){
            this.type = ' MINI | '
            this.icon = 'fas fa-user-ninja'
          }else if(actionType === 'adminuser'){
            this.type = ' ADMIN | '
            this.icon = 'fas fa-user-astronaut'
          }
          this.refreshToken()
          if (nav.items) {
            for (value of nav.items) {
              if (value.action.includes(actionType)) {
                data.push(value);
              }
            }
          }
        } else {
          this.removeToken()
        }
        return data
      } catch (error) {
        this.removeToken()
      }
    }
  }
}
</script>